export default __webpack_public_path__ + "static/media/brown-plus.ad7f3c3a.svg";